import styled from 'styled-components';

import {
  xdlColorTextInvert,
  xdlColorFocussed,
  spaceM,
  spaceXL,
  cornerRadiusM,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

/* Dummy wrapper */
export const Wrapper = styled.div`
  min-height: 96px;
`;

export const Box = styled.div`
  /* max on design tokens is borderRadius600 for 3px */
  border-top-right-radius: ${cornerRadiusM};
  border-top-left-radius: ${cornerRadiusM};
  padding: ${spaceXL};
  background-color: ${xdlColorFocussed};
  min-height: 175px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: 1113px) {
    /* max on design tokens is borderRadius600 for 3px */
    display: flex;
    flex-direction: row;
    justify-content: unset;
    min-height: auto;
    align-items: center;
  }
`;

export const AddCompanyHeadline = styled.div`
  color: ${xdlColorTextInvert};

  @media (min-width: 1113px) {
    flex: 1;
  }
`;

export const Header = styled.div`
  margin-bottom: ${spaceM};
  display: flex;
  justify-content: space-between;

  @media (min-width: 1113px) {
    justify-content: flex-start;
    margin-bottom: 0;
  }
`;

export const Title = styled(BodyCopy)`
  margin-bottom: 0;

  @media (min-width: 1113px) {
    margin-bottom: 0;
    font-size: 22px;
  }
`;

export const ContentText = styled(BodyCopy)`
  margin-bottom: ${spaceM};
  margin-top: ${spaceM};

  @media (min-width: 1113px) {
    margin: 0;
    font-size: 14px;
  }
`;
